module.exports = __webpack_public_path__ + "static/media/back-step.37b08cbd.svg";